<template>
  <custom-callout
    class="callout__extended"
    :controlled="true"
    :opened="value.isOpened"
    @click:open="onOpenDetails"
  >
    <div>
      <div class="row">
        <div class="col">
          <div class="row mt-4">
            <div class="col-2 col-sm col-6">
              <div class="color-black font-14 font-weight-bold">
                {{ value.serviceTypeMainName }}
              </div>
              <div class="color-black font-weight-normal font-16">
                {{ value.serviceTypeName }}
              </div>
            </div>
            <div class="col-1 col-sm col-6 d-sm-block d-md-none">
              <check-box v-model="value.checked" class="pl-5" />
            </div>
            <div class="col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3">
              <div class="color-secondary-6 font-14 font-weight-normal">
                Estudiante:
              </div>
              <div class="color-black font-weight-bold font-16">
                {{ value.studentFullName }}
              </div>
            </div>
            <div class="col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3">
              <div class="color-secondary-6 font-14 font-weight-normal">
                SIE:
              </div>
              <div class="color-black font-weight-bold font-16">
                {{ value.studentSieId }}
              </div>
            </div>
            <div class="col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3">
              <div class="color-secondary-6 font-14 font-weight-normal">
                Periodo:
              </div>
              <div class="color-black font-weight-bold font-16">
                {{ value.period }}
              </div>
            </div>
            <div class="col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3">
              <div class="color-secondary-6 font-14 font-weight-normal">
                Costo:
              </div>
              <div class="color-black font-weight-bold font-16">
                {{ value.costTotalAmt | price }}
              </div>
            </div>
            <div v-if="canDenyPayment" class="col-md-2 col-sm-12">
              <action-button
                id="btnCancel"
                class="outline-danger btn-cancel danger px-3 mr-2"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                @click="onOpenCloseSection"
              >
                Cancelar
              </action-button>
            </div>
            <div v-if="canMoveToJournal" class="col-md-auto col-sm-12">
              <drop-down :data-item="value" :items="actionItems" />
            </div>
            <div class="col-md-1 col-sm-12 d-md-block d-sm-none">
              <check-box v-model="value.isChecked" class="pl-5" />
            </div>
          </div>
        </div>
        <div class="col-1" style="max-width: 70px !important">
          <compact-nav-tabs
            :value="generalTabIndex"
            @on-select-tab-index="onSelectTabIndexHandler(index, value, $event)"
          />
        </div>
      </div>
    </div>
    <template #edition>
      <div v-if="!value.isOpenDenyPayment" class="bg-gray p-2">
        <div class="bg-white rounded">
          <custom-tab
            v-model="value.mainTabModel"
            content-class="mt-5"
            nav-class="custom-nav-container"
            :no-nav-style="true"
          >
            <custom-tab-item active lazy title="Información Adicional">
              <additional-info
                :is-thrpy-service="isTherapyService(value.peiAnalysisServiceId)"
                :thrpy-info="thrpyInfo || {}"
                :transportation-info="transportationInfo || {}"
                :value="value"
                @click="getAssistanceTherapyTransportationInfo(value)"
              />
            </custom-tab-item>
            <custom-tab-item
              :active="mainTabsEnum.ASSISTANCE_DETAILS === value.mainTabModel"
              lazy
              title="Detalles de Asistencia"
              @click="onSelectTabAssistanceDetails(index, value)"
            >
              <assistance-details
                :adjust-assistances="value.adjustAssistances"
                :adjust-periods="value.adjustPeriods"
                :assistance-service="value.assistanceService"
                :assistance-summary="value"
                :normal-assistances="value.normalAssistances"
                :selected-period="value.selectedPeriod"
                :show-assistance-service="showAssistanceService(value)"
              />
              <assistance-visit
                v-if="showAssistanceVisit(value.payrollReceiveTypeId)"
                :rows="value.assistanceVisitResult"
              />
            </custom-tab-item>
            <custom-tab-item
              :active="mainTabsEnum.PAYMENTS === value.mainTabModel"
              lazy
              title="Pagos"
              @click="onSelectTabPayment(value)"
            >
              <payment
                :additional-payments="payment.additionalPayments || []"
                :payment-relationship="payment.relationshipPayments"
                :status="1"
                :value="payment.payment || {}"
              />
            </custom-tab-item>
            <custom-tab-item
              :active="mainTabsEnum.HISTORY === value.mainTabModel"
              lazy
              title="Historial"
            >
              <history :id="value.assistanceSummaryId" class="mt-2" />
            </custom-tab-item>
            <custom-tab-item
              lazy
              title="Informe de Progreso"
              @click="onSelectTabProgressReport(value)"
            >
              <progress-inform :value="value.progressReport || {}" />
            </custom-tab-item>
          </custom-tab>
        </div>
      </div>
      <div v-if="value.isOpenDenyPayment" class="bg-gray p-2">
        <div class="bg-white rounded">
          <deny-payment
            :value="value"
            @on-cancel="onCleanDenySection"
            @on-confirm="onDenegateHandler"
          />
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import DropDown from 'dropdown';
import DenyPayment from './DenyPayment.vue';
import CompactNavTabs from '@/views/scholarship/attendance/components/CompactNavTabs.vue';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus.js';
import paymentJournalType from '@/utils/constants/paymentJournalType.js';
import {
  getAdditionalPaymentList as _getAdditionalPaymentList,
  getAssistanceDetailInfo as _getAssistanceDetailInfo,
  getAssistanceDetailPeriods as _getAssistanceDetailPeriods,
  getBillingAssistance as _getBillingAssistance,
  getPaymentDetail as _getPaymentDetail,
  getPaymentRelationship as _getPaymentRelationship,
  getProgressReport as _getProgressReport,
  getAssistanceTherapyInfo as _getAssistanceTherapyInfo,
  getAssistanceThransportationInfo as _getAssistanceTransportationInfo,
  getAssistanceDetailService as _getAssistanceDetailService,
} from '@/modules/shared/scholarship.api';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import serviceTypeEnum from '@/views/scholarship/attendance/utils/serviceTypeEnum';
import {
  Payment,
  AdditionalInfo,
  History,
  ProgressInform,
  AssistanceDetails,
  AssistanceVisit,
} from '../../../attendance/components/tabs';
import payrollReceiveTypes from '@/utils/constants/payrollReceiveTypes';

export default {
  name: 'PaymentInfoRow',
  components: {
    CustomCallout,
    ActionButton,
    CheckBox,
    DropDown,
    DenyPayment,
    CustomTab,
    CustomTabItem,
    Payment,
    AdditionalInfo,
    History,
    ProgressInform,
    AssistanceDetails,
    AssistanceVisit,
    CompactNavTabs,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    journalStatus: {
      type: Number,
      default: () => 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    isPendingTab: {
      type: Boolean,
      default: false,
    },
    journalType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      relationshipPayment: {
        services: null,
      },
      generalTabIndex: null,
      payment: {},
      thrpyInfo: null,
      transportationInfo: null,
    };
  },
  computed: {
    canDenyPayment() {
      return (
        this.journalStatus == paymentJournalStatus.Nuevo &&
        this.userHasPermissions('menu.scholarship.jornalpayment.denypayments')
      );
    },
    canMoveToJournal() {
      return (
        this.isPendingTab &&
        this.journalStatus === paymentJournalStatus.Nuevo &&
        this.journalType === paymentJournalType.ACH
      );
    },
    actionItems() {
      return [
        {
          name: 'move-to-journal',
          label: 'Mover a otro jornal',
          icon: 'fas fa-exchange-alt color-primary-1',
          click: () => {
            this.$emit('on-move-to-journal', this.value);
          },
        },
      ];
    },
    showAssistanceVisit() {
      return (id) =>
        id == payrollReceiveTypes.FacturacionEnLineaSAEE ||
        id == payrollReceiveTypes.FacturacionEnLineaRP;
    },
    mainTabsEnum() {
      return {
        ADDITIONAL_INFO: 0,
        ASSISTANCE_DETAILS: 1,
        PAYMENTS: 2,
        HISTORY: 3,
      };
    },
  },
  methods: {
    isTherapyService(serviceId) {
      return [
        serviceTypeEnum.terapiaDeHabla,
        serviceTypeEnum.terapiaOcupacional,
        serviceTypeEnum.terapidaPsicologica,
        serviceTypeEnum.terapiaFisica,
        serviceTypeEnum.terapiaOromotora,
      ].includes(serviceId);
    },
    async onSelectTabProgressReport({ assistanceSummaryId }) {
      if (assistanceSummaryId) {
        const { data: responseProgress } = await _getProgressReport(
          assistanceSummaryId
        );
        if (responseProgress) {
          this.value.progressReport = responseProgress;
          this.$forceUpdate();
        }
      }
    },
    async getAdjustmentAssistance(assistanceSummaryId, month, year) {
      return await _getAssistanceDetailInfo(
        assistanceSummaryId,
        false,
        month,
        year
      );
    },
    async onSelectTabAssistanceDetails(
      index,
      {
        assistanceSummaryId,
        payrollReceiveTypeId,
        studentSieId,
        academicYearId,
        monthNumber,
        peiAnalysisServiceId,
        isManualAssistanceFlag,
      }
    ) {
      if (isManualAssistanceFlag) {
        const { data: billingResponse } = await _getBillingAssistance(
          studentSieId,
          academicYearId,
          monthNumber,
          peiAnalysisServiceId,
          payrollReceiveTypeId,
          assistanceSummaryId
        );

        //get assistance service
        const { data: assistanceService } = await _getAssistanceDetailService(
          assistanceSummaryId
        );

        this.value['assistanceVisitResult'] = billingResponse;
        this.value['assistanceService'] = assistanceService;
      } else {
        const { data: responseNormal } = await _getAssistanceDetailInfo(
          assistanceSummaryId,
          true
        ); // normal assistances
        const { data: responsePeriods } = await _getAssistanceDetailPeriods(
          assistanceSummaryId
        ); //adjustment periods

        this.value['adjustPeriods'] = responsePeriods.map((x) => {
          x.monthShortName = x.monthShortName.replace('.', '');
          return x;
        });

        this.value['normalAssistances'] = responseNormal;

        if (responsePeriods) {
          const firstPeriod = responsePeriods[0];
          if (firstPeriod) {
            const { data: responseAdjust } = await this.getAdjustmentAssistance(
              assistanceSummaryId,
              firstPeriod.monthNumber,
              firstPeriod.year
            );

            this.value['adjustAssistances'] = responseAdjust;

            //set first as selected
            this.value['selectedPeriod'] = firstPeriod.id;
          }
        }
      }
      this.$forceUpdate();
    },

    async onSelectTabPayment(item) {
      if (item.assistanceSummaryId && item.academicYearId) {
        const responses = await Promise.all([
          _getPaymentDetail(item.assistanceSummaryId, item.academicYearId),
          _getAdditionalPaymentList(item.assistanceSummaryId),
          _getPaymentRelationship(item.assistanceSummaryId),
        ]);
        this.payment = {
          payment: responses[0].data,
          additionalPayments: responses[1].data,
          relationshipPayments: responses[2].data || {},
        };
      }
    },
    onOpenCloseSection() {
      this.$emit('on-open-deny-section', {
        itemIndex: this.index,
        propName: 'isOpenDenyPayment',
      });
      this.value.isOpened = true;
      this.$forceUpdate();
    },
    onCleanDenySection() {
      this.$emit('on-open-deny-section', {
        itemIndex: this.index,
        propName: 'isOpenDenyPayment',
      });
      this.value.isOpened = false;
      this.$forceUpdate();
    },
    async onDenegateHandler(assistanceSummaryId, comment) {
      this.$emit('on-denegate-item', assistanceSummaryId, comment);
    },
    async onOpenDetails() {
      this.value.isOpenDenyPayment = false;
      this.$emit('on-open-additional-section', {
        itemIndex: this.index,
        propName: 'isOpened',
      });
      if (
        this.value.isOpened &&
        (!this.value.mainTabModel ||
          this.value.mainTabModel == this.mainTabsEnum.ADDITIONAL_INFO)
      ) {
        await this.getAssistanceTherapyTransportationInfo(this.value);
      }
      this.$forceUpdate();
    },
    async onSelectTabIndexHandler(rowIndex, item, tabIndex) {
      item.mainTabModel = tabIndex;
      await this.$forceUpdate();

      if (tabIndex == 0) {
        await this.getAssistanceTherapyTransportationInfo(item);
      }
      if (tabIndex == 1) {
        await this.onSelectTabAssistanceDetails(rowIndex, item);
      }
      if (tabIndex == 2) {
        await this.onSelectTabPayment(item);
      }
      this.$emit('on-open-general-additional-section', {
        itemIndex: this.index,
        generalTabIndex: tabIndex,
      });
    },
    async getAssistanceTherapyTransportationInfo(item) {
      if (this.isTherapyService(item.peiAnalysisServiceId)) {
        this.thrpyInfo = (
          await _getAssistanceTherapyInfo(
            item.academicYearId,
            item.studentSieId,
            item.peiAnalysisServiceId
          )
        ).data;
      }
      this.transportationInfo = (
        await _getAssistanceTransportationInfo(
          item.academicYearId,
          item.studentSieId,
          item.peiAnalysisServiceId
        )
      ).data;
    },
    showAssistanceService(item) {
      return item.isManualAssistanceFlag === true;
    },
  },
};
</script>

<style scoped lang="scss">
.callout__extended ::v-deep {
  .col.p-2.ml-2 {
    padding: unset !important;
  }
}
@media only screen and (max-width: 768px) {
  .btn-block-xs-only {
    display: block;
    width: 100%;
    margin-top: 20px;
  }
}
</style>
